import ContentParser from './ContentParser';
export default ContentParser;
